module.exports = __webpack_public_path__ + "static/media/8.137e215e.jpg";